<template>
    <el-row style="margin: 30px 0 30px 0;">
        <el-button @click="show = true">点击此处添加新的订单评审表</el-button>
    </el-row>

    <hr>

    <h3 style="margin-top: 20px;">本月</h3>

    <div style="display: flex; flex-direction: row; margin-top: 20px; ">
        <div
            style="user-select: none; cursor: pointer; box-shadow: 5px 5px 20px gray; width: 400px; height: 200px; background-color: #FFF; border: 1px solid #999;  display: flex; flex-direction: column;border-radius: 5px;">
            <div
                style="border-radius: 5px 5px 0 0;padding:10px 0 10px 0; background-color: #EEE; font-size: 14px; display: flex; flex-direction: row; justify-content:space-between">
                <div style="align-self: flex-start; margin-left: 10px;">测试的订单评审表</div>

                <div style="align-self: flex-end;  margin-right: 10px; display: flex; flex-direction: row;">

                    <div>
                        <svg style="margin-bottom: 2px;" width="15" height="15" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="8" fill="#22c55e" opacity=".3" />
                            <path fill="#22c55e"
                                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8z" />
                        </svg>
                    </div>

                    <div style=" margin-left:5px;">已通过</div>
                </div>
            </div>
            <div style="display: flex;flex-grow: 1; padding: 10px; ">这是一个测试的订单评审表</div>
            <div
                style="display: flex;flex-direction: row; margin-top: 20px;justify-content: center; background-color: #EEE;  border-radius: 0 0 5px 5px;">
                <svg style="margin-top: 10px;" width="15" height="15" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor"
                        d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 7c2.67 0 8 1.33 8 4v3H4v-3c0-2.67 5.33-4 8-4m0 1.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1Z" />
                </svg>
                <div style=" line-height: 15px; padding:10px 0px 10px 5px;">张三</div>
            </div>


        </div>


        <div
            style=" margin-left: 40px; width: 400px; height: 200px; background-color: #FFF; border: 1px solid #999;  display: flex; flex-direction: column;border-radius: 5px;">
            <div
                style="border-radius: 5px 5px 0 0;padding:10px 0 10px 0; background-color: #EEE; font-size: 14px; display: flex; flex-direction: row; justify-content:space-between">
                <div style="align-self: flex-start; margin-left: 10px;">测试的订单评审表</div>

                <div style="align-self: flex-end;  margin-right: 10px; display: flex; flex-direction: row;">

                    <div>
                        <svg style="margin-bottom: 2px;" width="15" height="15" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="8" fill="#CCC" opacity=".3" />
                            <path fill="#999"
                                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8z" />
                        </svg>
                    </div>

                    <div style=" margin-left:5px;">待审核</div>
                </div>
            </div>
            <div style="display: flex;flex-grow: 1; padding: 10px; ">这是一个测试的订单评审表</div>
            <div
                style="display: flex;flex-direction: row; margin-top: 20px;justify-content: center; background-color: #EEE; ">
                <svg style="margin-top: 10px;" width="15" height="15" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor"
                        d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 7c2.67 0 8 1.33 8 4v3H4v-3c0-2.67 5.33-4 8-4m0 1.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1Z" />
                </svg>
                <div style=" line-height: 15px; padding:10px 0px 10px 5px;">责任人asdfdsf</div>
            </div>


        </div>
    </div>

    <h3 style="margin-top: 40px;">8月</h3>

    <div style="display: flex; flex-direction: row; margin-top: 20px; ">
        <div
            style=" width: 400px; height: 200px; background-color: #FFF; border: 1px solid #999;  display: flex; flex-direction: column;border-radius: 5px;">
            <div
                style="border-radius: 5px 5px 0 0;padding:10px 0 10px 0; background-color: #EEE; font-size: 14px; display: flex; flex-direction: row; justify-content:space-between">
                <div style="align-self: flex-start; margin-left: 10px;">测试的订单评审表</div>

                <div style="align-self: flex-end;  margin-right: 10px; display: flex; flex-direction: row;">

                    <div>
                        <svg style="margin-bottom: 2px;" width="15" height="15" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="8" fill="#22c55e" opacity=".3" />
                            <path fill="#22c55e"
                                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8z" />
                        </svg>
                    </div>

                    <div style=" margin-left:5px;">已通过</div>
                </div>
            </div>
            <div style="display: flex;flex-grow: 1; padding: 10px; ">这是一个测试的订单评审表</div>
            <div
                style="display: flex;flex-direction: row; margin-top: 20px;justify-content: center; background-color: #EEE; ">
                <svg style="margin-top: 10px;" width="15" height="15" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor"
                        d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 7c2.67 0 8 1.33 8 4v3H4v-3c0-2.67 5.33-4 8-4m0 1.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1Z" />
                </svg>
                <div style=" line-height: 15px; padding:10px 0px 10px 5px;">责任人asdfdsf</div>
            </div>


        </div>

        <el-dialog :close-on-click-modal="false" v-model="show">
            <el-row justify="center" align="middle">
                <el-col :span="2">
                    <el-lable>名称</el-lable>
                </el-col>
                <el-col :span="6"> <el-input>fdsf</el-input> </el-col>

            </el-row>
            <br>
            <el-row justify="center" align="middle">
                <el-col :span="3">
                    <el-lable>业务负责人</el-lable>
                </el-col>
                <el-col :span="6"> <el-input>fdsf</el-input> </el-col>
                <el-col :offset="1" :span="3">
                    <el-lable>研发负责人</el-lable>
                </el-col>
                <el-col :span="6"> <el-input>fdsf</el-input> </el-col>
            </el-row>
            <br>
            <el-row justify="center" align="middle">
                <el-col :span="3">
                    <el-lable>电机</el-lable>
                </el-col>
                <el-col :span="6"> <el-input>fdsf</el-input> </el-col>
                <el-col :offset="1" :span="3">
                    <el-lable>马达座</el-lable>
                </el-col>
                <el-col :span="6"> <el-input>fdsf</el-input> </el-col>
            </el-row>
            <br>
            <el-row justify="center" align="middle">
                <el-col :span="3">
                    <el-lable>线缆</el-lable>
                </el-col>
                <el-col :span="6"> <el-input>fdsf</el-input> </el-col>
                <el-col :offset="1" :span="3">
                    <el-lable>码表</el-lable>
                </el-col>
                <el-col :span="6"> <el-input>fdsf</el-input> </el-col>
            </el-row>

            <br>
            <hr>
            <br>
            <el-row justify="center" align="middle">
                <el-col :span="3">
                    <el-button @click="show=false">取消</el-button>
                </el-col>

                <el-col :offset="1" :span="2">
                    <el-button type="primary">确认</el-button>
                </el-col>

            </el-row>
        </el-dialog>
    </div>
</template>
 
<script>
export default {
    data() {
        return {
            show: false
        }
    }
}
</script>